import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Grid } from '@mui/material';


const ParticipantDetails = ({participant, close, resetParticipant}) => {
    //let properties = participant !== null ? Object.keys(participant) : []
    //console.log(properties)
    
    const handleClose = () => {  close()  };

    const handleResetParticipant = () => {
        resetParticipant(participant.capnr)
    }

    if (participant === null) 
        return (<div />);
    return (
        <div>
        <Dialog maxWidth='sm' fullWidth open={(participant.capnr.length > 0)} onClick={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Deelnemer met Capnr: {participant.capnr}</DialogTitle>
        <DialogContent>
            <Box className='participant'>
                <Grid container columns={5}>
                    <Grid item id="Label01" xs={2}>Voornaam</Grid><Grid item xs={3}>{participant.firstName}</Grid>
                    <Grid item id="Label02" xs={2}>Achternaam</Grid><Grid item xs={3}>{participant.lastName}</Grid>
                    <Grid item id="Label03" xs={2}>Postcode</Grid><Grid item xs={3}>{participant.zipcode}</Grid>
                    <Grid item id="Label04" xs={2}>Huisnummer</Grid><Grid item xs={3}>{participant.houseNumber}</Grid>
                    <Grid item id="Label05" xs={2}>Afstand</Grid><Grid item xs={3}>{participant.distance}</Grid>
                    <Grid item id="Label06" xs={2}>Geboortedag</Grid><Grid item xs={3}>{participant.birthday}</Grid>
                    <Grid item id="Label07" xs={2}>Leeftijd</Grid><Grid item xs={3}>{participant.age}</Grid>
                    <Grid item id="Label08" xs={2}>Team</Grid><Grid item xs={3}>{participant.teamName}</Grid>
                    <Grid item id="Label09" xs={2}>Wave</Grid><Grid item xs={3}>{participant.wave}</Grid>
                    <Grid item id="Label10" xs={2}>Compleet?</Grid><Grid item xs={3}>{participant.complete}</Grid>
                    <Grid item id="Label11" xs={2}>Status</Grid><Grid item xs={3}>{participant.state}</Grid>
                    <Grid item id="Label12" xs={2}>Email</Grid><Grid item xs={3}>{participant.email?participant.email:"verzonden"}</Grid>
                    <Grid item id="Label13" xs={2}>ICE voornaam</Grid><Grid item xs={3}>{participant.iceFirstName}</Grid>
                    <Grid item id="Label14" xs={2}>ICE achternaam</Grid><Grid item xs={3}>{participant.iceLastName}</Grid>
                    <Grid item id="Label15" xs={2}>ICE telefoon</Grid><Grid item xs={3}>{participant.icePhone1}</Grid>
                    {participant.icePhone2 && <><Grid item id="Label16" xs={2}>ICE telefoon 2</Grid><Grid item xs={3}>{participant.icePhone2}</Grid></>}
                    {participant.icePhone3 && <><Grid item id="Label17" xs={2}>ICE telefoon 3</Grid><Grid item xs={3}>{participant.icePhone3}</Grid></>}
                </Grid>
            </Box>
        </DialogContent>
        <DialogActions>
            {participant.state === "registered" && <Button onClick={handleResetParticipant} color="secondary">
            Registratie wijzigen
          </Button>}
          <Button onClick={handleClose} color="primary">
            Sluiten
          </Button>
        </DialogActions>
        </Dialog>
        </div>
    )
}


/*
    Does not seem to work to dynamically access objects
            {
                typeof participant === 'object' && participant !== null && properties.map((key, i) => (
                <p key={i}>
                    <span>{key}</span>
                    <span>{participant[key]}</span>
                </p>
            ))
        }
*/
export default ParticipantDetails
